window.aboundLoadContentAjax = (containerEl, requestUrl) => {
    if(!containerEl) return

    return fetch(requestUrl, {
        method: 'get',
        credentials: "same-origin", // won't send cookies without this
    })
        .then(x => x.text())
        .then(html => {
            containerEl.innerHTML = html
            const scriptEls = [...containerEl.querySelectorAll('script')]

            // scripts aren't run by setting them in innerHTML, so need to run them by recreating them
            // need to execute scripts in order (in case some rely on others), so will wait for each to load to load next
            const processScripts = () => {
                if(!scriptEls.length) return

                const nextScriptEl = scriptEls.shift()
                const dupeScriptEl = document.createElement('script')
                dupeScriptEl.onload = processScripts
                if(nextScriptEl.src) dupeScriptEl.src = nextScriptEl.src

                nextScriptEl.childNodes.forEach(childNode => {
                    dupeScriptEl.appendChild(childNode.cloneNode())
                })

                containerEl.appendChild(dupeScriptEl)
            }

            processScripts()
        })
}



// WEBPACK FOOTER //
// ./load-content-ajax.js